import { theme } from 'lib';
import CurrencyInput from 'react-currency-input-field';
import styled from 'styled-components';

const inputStyles = (props) => `
  height: 25px;
  width: ${props.wid || '100px'};
  padding: 4px;
  margin: ${props.marg || 0};
  border-radius: 5px;
  border: 1px solid ${theme.GREY_50};
  text-align: ${props.center ? 'center' : 'left'};

  &:focus {
    outline: #000 solid 2px;
  }
`;

const CustomInput = styled.input`
  ${(props) => inputStyles(props)}
`;

const CustomCurrencyInput = styled(CurrencyInput)`
  ${(props) => inputStyles(props)}
`;

const ValueInput = (props) => {
  return props.currency ? <CustomCurrencyInput {...props} /> : <CustomInput {...props} />;
};

export default ValueInput;
